import React from 'react';
import Dashboard from './Dashboard/Dashboard.jsx';
import PublicSettings from './Settings/PublicSettings.jsx';
import DriversSettings from './Settings/Drivers/Drivers';
import FreightsSettings from './Settings/Freights/Freights';
import OperatorsSettings from './Settings/Operators/Operators';
import ParametersIndex from './Parameters/';
import Cities from './Parameters/Cities/Cities';
import StatesPage from './Parameters/StatesPage/StatesPage';
import UsersIndex from './Users/';
import SettingsIndex from './Settings/';
import AddSlider from './Settings/Slider/AddSlider';
import OrdersIndex from './Orders/';
import Loads from './Parameters/Loads';
import Fleets from './Parameters/Fleets/Fleets';
import CargoTypes from './Parameters/CargoTypes';
import Packages from './Parameters/packages';
import Insurance from './Calculations/InsuranceSubtractions/InsuranceSubtractions';
import CalcCities from './Calculations/Cities';
import CommissionsParams from './Calculations/CommissionsParams/CommissionsParams';
import WaybillsParams from './Calculations/WaybillsParams/WaybillsParams';
import DistancePercent from './Calculations/DistancePercent';
import Commission from './Calculations/Commission/Commission';
import BasePrice from './Calculations/BasePrice/BasePrice';
import AddBasePrice from './Calculations/AddBasePrice/AddBasePrice';
import CalculationsIndex from './Calculations/';
import GeneralParams from './Parameters/GeneralParams';
import Drivers from './Users/Drivers/Drivers';
import FreightUsersList from './Users/Freights/Freights';
import Customers from './Users/Customers/Customers';
import UploadExcellForWayBills from './Calculations/CitiesCalculations/UploadExcellForWayBills';
import WayBillByOrigin from './Calculations/CitiesCalculations/CitiesCalculations';
import ChangePass from './Settings/Password/Password';
import Reports from './Reports/Reports';
import FreightsList from './Freights/FreightsList';
import Freight from './Freights/Freights.jsx';

// icons
import DashboardIcon from '../../../assets/svg/dashboardIcon.svg';
import UsersIcon from '../../../assets/svg/usersIcon.svg';
import SettingsIcon from '../../../assets/svg/settingsIcon.svg';
import ParametersIcon from '../../../assets/svg/paramsIcon.svg';
import OrdersIcon from '../../../assets/svg/ordersIcon.svg';
import CalculationsIcon from '../../../assets/svg/calculationsIcon.svg';
import PasswordIcon from '../../../assets/svg/passwordIcon.svg';
import reportIcon from '../../../assets/svg/report.svg';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';

const dashboardRoutes = [
  {
    path: '/dashboard',
    slug: 'sidemenu_dashboard',
    name: 'داشبورد',
    icon: <img src={DashboardIcon} alt="" width="32" height="32" />,
    component: Dashboard,
  },
  {
    path: '/freights',
    slug: 'sidemenu_freights',
    name: 'باربری‌ها',
    // icon: <img src={PasswordIcon} alt="" width="32" height="32" />,
    icon: <LocalShippingIcon fontSize="large" style={{ color: 'black' }} />,
    component: Freight,
    childs: [
      {
        path: '/freights/freightsOrders',
        slug: 'freights_orders',
        name: 'لیست سفارشات',
        component: FreightsList,
        parent: 'freights',
      },
    ],
  },

  {
    path: '/orders',
    slug: 'sidemenu_orders',
    name: 'مدیریت سفارشات',
    icon: <img src={OrdersIcon} alt="" width="32" height="32" />,
    component: OrdersIndex,
  },
  {
    path: '/users',
    slug: 'sidemenu_users',
    name: 'مدیریت کاربران',
    icon: <img src={UsersIcon} alt="" width="32" height="32" />,
    component: UsersIndex,
    childs: [
      {
        path: '/users/drivers',
        slug: 'drivers',
        name: 'مدیریت رانندگان',
        icon: 'pe-7s-users',
        component: Drivers,
        parent: 'users',
      },
      {
        path: '/users/customers',
        slug: 'customers',
        name: 'مدیریت صاحبان بار',
        component: Customers,
        parent: 'users',
      },
      {
        path: '/users/freights',
        slug: 'freights',
        name: 'مدیریت باربری‌ها',
        component: FreightUsersList,
        parent: 'users',
      },
    ],
  },

  {
    path: '/reports',
    slug: 'sidemenu_reports',
    name: 'گزارش‌ها',
    icon: <img src={reportIcon} alt="" width="32" height="32" />,
    component: Reports,
    childs: [
      {
        path: '/reports/rejects',
        slug: 'reports_rejected',
        name: 'گزارش سفارش‌های رد شده',
        parent: 'reports',
      },
      {
        path: '/reports/cancels',
        slug: 'reports_canceled',
        name: 'گزارش سفارش‌های کنسل شده',
        parent: 'reports',
      },
      {
        path: '/reports/returns',
        slug: 'reports_returned',
        name: 'گزارش سفارش‌های برگشت خورده',
        parent: 'reports',
      },
      {
        path: '/reports/ready',
        slug: 'reports_ready',
        name: 'گزارش سفارش‌های بارگیری شده',
        parent: 'reports',
      },
      {
        path: '/reports/commissions',
        slug: 'reports_commissions',
        name: 'گزارش پورسانت‌ها',
        parent: 'reports',
      },
      {
        path: '/reports/insuranceExpiry',
        slug: 'reports_insurances',
        name: 'سررسید بیمه‌نامه‌ها',
        parent: 'reports',
      },
      {
        path: '/reports/Deposits?role=customer&role=driver',
        slug: 'reports_commissions_deposited',
        name: 'گزارش واریزی ها',
        parent: 'reports',
      },
      {
        path: '/reports/onlineUsers',
        slug: 'reports_customers',
        name: 'گزارش نصب ها - صاحبین بار',
        parent: 'reports',
      },
      {
        path: '/reports/onlineDrivers',
        slug: 'reports_drivers',
        name: 'گزارش نصب ها - رانندگان',
        parent: 'reports',
      },
    ],
  },
  {
    path: '/parameters',
    slug: 'sidemenu_parameters',
    name: 'مدیریت پارامترها',
    icon: <img src={ParametersIcon} alt="" width="32" height="32" />,
    component: ParametersIndex,
    childs: [
      {
        path: '/parameters/cities',
        slug: 'parameters_cities',
        name: 'شهرها',
        component: Cities,
        parent: 'parameters',
      },
      {
        path: '/parameters/states',
        slug: 'parameters_states',
        name: 'استانها',
        component: StatesPage,
        parent: 'parameters',
      },
      {
        path: '/parameters/loads',
        slug: 'parameters_load',
        name: 'وضعیت بارگیری',
        component: Loads,
        parent: 'parameters',
      },
      {
        path: '/parameters/cargo-types',
        slug: 'parameters_cargo',
        name: 'انواع محموله',
        component: CargoTypes,
        parent: 'parameters',
      },
      {
        path: '/parameters/packages',
        slug: 'parameters_packages',
        name: 'انواع بسته بندی',
        component: Packages,
        parent: 'parameters',
      },
      {
        path: '/parameters/fleets',
        slug: 'parameters_fleets',
        name: 'انواع ناوگان',
        component: Fleets,
        parent: 'parameters',
      },
      {
        path: '/parameters/generalParams',
        slug: 'parameters_general',
        name: 'پارامترهای کلی',
        component: GeneralParams,
        parent: 'parameters',
      },
    ],
  },
  {
    path: '/calculations',
    slug: 'sidemenu_calculations',
    name: 'محاسبات',
    icon: <img src={CalculationsIcon} alt="" width="32" height="32" />,
    component: CalculationsIndex,
    childs: [
      {
        path: '/calculations/addBasePrice',
        slug: 'calculations_add_base_price',
        name: 'افزودن کرایه',
        component: AddBasePrice,
        parent: 'calculations',
      },
      {
        path: '/calculations/basePrice',
        slug: 'calculations_base_price_calculations',
        name: 'محاسبه کرایه',
        component: BasePrice,
        parent: 'calculations',
      },
      {
        path: '/calculations/commissionsParams',
        slug: 'calculations_parameters',
        name: 'پارامترهای کمیسیون',
        component: CommissionsParams,
        parent: 'calculations',
      },
      {
        path: '/calculations/commission',
        slug: 'calculations_commissions',
        name: 'ضرایب مالی',
        component: Commission,
        parent: 'calculations',
      },
      {
        path: '/calculations/insurance',
        slug: 'calculations_insurances',
        name: 'بیمه بار',
        component: Insurance,
        parent: 'calculations',
      },

      {
        path: '/calculations/waybillsParams',
        slug: 'calculations_waybill_parameters',
        name: 'پارامترهای کرایه‌حمل',
        component: WaybillsParams,
        parent: 'calculations',
      },
      {
        path: '/calculations/cities',
        slug: 'calculations_cities',
        name: 'ضریب شهرها',
        component: CalcCities,
        parent: 'calculations',
      },
      {
        path: '/calculations/distancePercent',
        slug: 'calculations_distance',
        name: 'ضریب مسافت',
        component: DistancePercent,
        parent: 'calculations',
      },
      {
        path: '/calculations/waybillByOrigin',
        slug: 'calculations_waybillByOrigin',
        name: 'تعین کرایه شهر به شهر',
        component: WayBillByOrigin,
        parent: 'calculations',
      },
      {
        path: '/calculations/uploadWayBillExcell',
        slug: 'calculations_waybills_upload',
        name: 'آپلود فایل کرایه ها',
        component: UploadExcellForWayBills,
        parent: 'calculations',
      },
    ],
  },
  {
    path: '/settings',
    slug: 'sidemenu_settings',
    name: 'مدیریت تنظیمات',
    icon: <img src={SettingsIcon} alt="" width="32" height="32" />,
    component: SettingsIndex,
    childs: [
      {
        path: '/settings/operators',
        slug: 'settings_operators',
        name: 'تنظیمات کارشناسان حمل',
        component: OperatorsSettings,
        parent: 'settings',
      },
      {
        path: '/settings/drivers',
        slug: 'settings_drivers',
        name: 'تنظیمات رانندگان',
        component: DriversSettings,
        parent: 'settings',
      },
      {
        path: '/settings/freights',
        slug: 'settings_freights',
        name: 'تنظیمات باربری ها',
        component: FreightsSettings,
        parent: 'settings',
      },
      {
        path: '/settings/sliders',
        slug: 'settings_sliders',
        name: 'اسلایدرهای سایت',
        component: AddSlider,
        parent: 'settings',
      },
      {
        path: '/settings/public',
        slug: 'settings_public',
        name: 'تنظیمات عمومی',
        component: PublicSettings,
        parent: 'settings',
      },
    ],
  },
  {
    path: '/password',
    slug: 'sidemenu_password',
    name: 'کلمه عبور',
    icon: <img src={PasswordIcon} alt="" width="32" height="32" />,
    component: ChangePass,
  },
];

export default dashboardRoutes;
